import { binaryToGeometry } from '@loaders.gl/gis';
import { WKBLoader, WKTLoader } from '@loaders.gl/wkt';
export function parseGeometryFromArrow(arrowCellValue, encoding) {
  var _encoding;
  encoding = (_encoding = encoding) === null || _encoding === void 0 ? void 0 : _encoding.toLowerCase();
  if (!encoding || !arrowCellValue) {
    return null;
  }
  let geometry;
  switch (encoding) {
    case 'geoarrow.multipolygon':
      geometry = arrowMultiPolygonToFeature(arrowCellValue);
      break;
    case 'geoarrow.polygon':
      geometry = arrowPolygonToFeature(arrowCellValue);
      break;
    case 'geoarrow.multipoint':
      geometry = arrowMultiPointToFeature(arrowCellValue);
      break;
    case 'geoarrow.point':
      geometry = arrowPointToFeature(arrowCellValue);
      break;
    case 'geoarrow.multilinestring':
      geometry = arrowMultiLineStringToFeature(arrowCellValue);
      break;
    case 'geoarrow.linestring':
      geometry = arrowLineStringToFeature(arrowCellValue);
      break;
    case 'geoarrow.wkb':
      geometry = arrowWKBToFeature(arrowCellValue);
      break;
    case 'geoarrow.wkt':
      geometry = arrowWKTToFeature(arrowCellValue);
      break;
    default:
      {
        throw Error(`GeoArrow encoding not supported ${encoding}`);
      }
  }
  return geometry;
}
function arrowWKBToFeature(arrowCellValue) {
  var _WKBLoader$parseSync;
  const arrayBuffer = arrowCellValue.buffer.slice(arrowCellValue.byteOffset, arrowCellValue.byteOffset + arrowCellValue.byteLength);
  const binaryGeometry = (_WKBLoader$parseSync = WKBLoader.parseSync) === null || _WKBLoader$parseSync === void 0 ? void 0 : _WKBLoader$parseSync.call(WKBLoader, arrayBuffer);
  const geometry = binaryToGeometry(binaryGeometry);
  return geometry;
}
function arrowWKTToFeature(arrowCellValue) {
  var _WKTLoader$parseTextS;
  const string = arrowCellValue;
  return (_WKTLoader$parseTextS = WKTLoader.parseTextSync) === null || _WKTLoader$parseTextS === void 0 ? void 0 : _WKTLoader$parseTextS.call(WKTLoader, string);
}
function arrowMultiPolygonToFeature(arrowMultiPolygon) {
  const multiPolygon = [];
  for (let m = 0; m < arrowMultiPolygon.length; m++) {
    const arrowPolygon = arrowMultiPolygon.get(m);
    const polygon = [];
    for (let i = 0; arrowPolygon && i < (arrowPolygon === null || arrowPolygon === void 0 ? void 0 : arrowPolygon.length); i++) {
      const arrowRing = arrowPolygon === null || arrowPolygon === void 0 ? void 0 : arrowPolygon.get(i);
      const ring = [];
      for (let j = 0; arrowRing && j < arrowRing.length; j++) {
        const arrowCoord = arrowRing.get(j);
        const coord = Array.from(arrowCoord);
        ring.push(coord);
      }
      polygon.push(ring);
    }
    multiPolygon.push(polygon);
  }
  const geometry = {
    type: 'MultiPolygon',
    coordinates: multiPolygon
  };
  return geometry;
}
function arrowPolygonToFeature(arrowPolygon) {
  const polygon = [];
  for (let i = 0; arrowPolygon && i < arrowPolygon.length; i++) {
    const arrowRing = arrowPolygon.get(i);
    const ring = [];
    for (let j = 0; arrowRing && j < arrowRing.length; j++) {
      const arrowCoord = arrowRing.get(j);
      const coords = Array.from(arrowCoord);
      ring.push(coords);
    }
    polygon.push(ring);
  }
  const geometry = {
    type: 'Polygon',
    coordinates: polygon
  };
  return geometry;
}
function arrowMultiPointToFeature(arrowMultiPoint) {
  const multiPoint = [];
  for (let i = 0; arrowMultiPoint && i < arrowMultiPoint.length; i++) {
    const arrowPoint = arrowMultiPoint.get(i);
    if (arrowPoint) {
      const coord = Array.from(arrowPoint);
      multiPoint.push(coord);
    }
  }
  return {
    type: 'MultiPoint',
    coordinates: multiPoint
  };
}
function arrowPointToFeature(arrowPoint) {
  const point = Array.from(arrowPoint);
  return {
    type: 'Point',
    coordinates: point
  };
}
function arrowMultiLineStringToFeature(arrowMultiLineString) {
  const multiLineString = [];
  for (let i = 0; arrowMultiLineString && i < arrowMultiLineString.length; i++) {
    const arrowLineString = arrowMultiLineString.get(i);
    const lineString = [];
    for (let j = 0; arrowLineString && j < arrowLineString.length; j++) {
      const arrowCoord = arrowLineString.get(j);
      if (arrowCoord) {
        const coords = Array.from(arrowCoord);
        lineString.push(coords);
      }
    }
    multiLineString.push(lineString);
  }
  return {
    type: 'MultiLineString',
    coordinates: multiLineString
  };
}
function arrowLineStringToFeature(arrowLineString) {
  const lineString = [];
  for (let i = 0; arrowLineString && i < arrowLineString.length; i++) {
    const arrowCoord = arrowLineString.get(i);
    if (arrowCoord) {
      const coords = Array.from(arrowCoord);
      lineString.push(coords);
    }
  }
  return {
    type: 'LineString',
    coordinates: lineString
  };
}
//# sourceMappingURL=convert-geoarrow-to-geojson-geometry.js.map